"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserApi = exports.ProfessionCode = exports.GenderCode = exports.SubscriptionSource = exports.AccountType = void 0;
const axios_1 = require("axios");
const globalImportUrl = require("url");
const base_1 = require("../base");
var AccountType;
(function (AccountType) {
    AccountType["Free"] = "free";
    AccountType["Sec"] = "sec";
    AccountType["Cac"] = "cac";
    AccountType["BigAccount"] = "bigAccount";
    AccountType["Invited"] = "invited";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var SubscriptionSource;
(function (SubscriptionSource) {
    SubscriptionSource["None"] = "none";
    SubscriptionSource["Ios"] = "ios";
})(SubscriptionSource = exports.SubscriptionSource || (exports.SubscriptionSource = {}));
var GenderCode;
(function (GenderCode) {
    GenderCode["Male"] = "male";
    GenderCode["Female"] = "female";
    GenderCode["Undefined"] = "undefined";
})(GenderCode = exports.GenderCode || (exports.GenderCode = {}));
var ProfessionCode;
(function (ProfessionCode) {
    ProfessionCode["CerealCrops"] = "cerealCrops";
    ProfessionCode["OilSeedsAndProteinCrops"] = "oilSeedsAndProteinCrops";
    ProfessionCode["IndustrialCrops"] = "industrialCrops";
    ProfessionCode["MeatyCattleBreeding"] = "meatyCattleBreeding";
    ProfessionCode["DairyCattleBreeding"] = "dairyCattleBreeding";
    ProfessionCode["PigFarming"] = "pigFarming";
    ProfessionCode["SheepAndGoatFarming"] = "sheepAndGoatFarming";
    ProfessionCode["PoultryFarming"] = "poultryFarming";
    ProfessionCode["OtherBreeding"] = "otherBreeding";
    ProfessionCode["Viticulture"] = "viticulture";
    ProfessionCode["MarketGardening"] = "marketGardening";
    ProfessionCode["Arboriculture"] = "arboriculture";
    ProfessionCode["OtherAgriculturalActivity"] = "otherAgriculturalActivity";
    ProfessionCode["NonAgriculturalActivity"] = "nonAgriculturalActivity";
})(ProfessionCode = exports.ProfessionCode || (exports.ProfessionCode = {}));
function UserApiAxiosParamCreator(configuration) {
    return {
        activateAccount(Activate, options = {}) {
            if (Activate === null || Activate === undefined) {
                throw new base_1.RequiredError("Activate", "Required parameter Activate was null or undefined when calling activateAccount.");
            }
            const localVarPath = `/account/activate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            const needsSerialization = typeof Activate !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(Activate !== undefined ? Activate : {})
                : Activate || "";
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        checkSubscription(options = {}) {
            const localVarPath = `/account/check-subscription`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteUser(options = {}) {
            const localVarPath = `/account`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "DELETE" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteUserService(slug, options = {}) {
            if (slug === null || slug === undefined) {
                throw new base_1.RequiredError("slug", "Required parameter slug was null or undefined when calling deleteUserService.");
            }
            const localVarPath = `/account/services/{slug}`.replace(`{slug}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "DELETE" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        forgotEmail(ezCookieValue, options = {}) {
            if (ezCookieValue === null || ezCookieValue === undefined) {
                throw new base_1.RequiredError("EZCookieValue", "Required parameter EZCookieValue was null or undefined when calling forgotEmail.");
            }
            const localVarPath = `/account/forgot-email`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            const needsSerialization = typeof ezCookieValue !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(ezCookieValue !== undefined ? ezCookieValue : {})
                : ezCookieValue || "";
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAccount(options = {}) {
            const localVarPath = `/account`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getSubscription(options = {}) {
            const localVarPath = `/account/subscription`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getUserService(slug, options = {}) {
            if (slug === null || slug === undefined) {
                throw new base_1.RequiredError("slug", "Required parameter slug was null or undefined when calling getUserService.");
            }
            const localVarPath = `/account/services/{slug}`.replace(`{slug}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getUserServices(options = {}) {
            const localVarPath = `/account/services`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getUsernameValidity(username, options = {}) {
            if (username === null || username === undefined) {
                throw new base_1.RequiredError("username", "Required parameter username was null or undefined when calling getUsernameValidity.");
            }
            const localVarPath = `/account/username-validity`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (username !== undefined) {
                localVarQueryParameter["username"] = username;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        insertUserService(RequestBodySlug, options = {}) {
            if (RequestBodySlug === null || RequestBodySlug === undefined) {
                throw new base_1.RequiredError("RequestBodySlug", "Required parameter RequestBodySlug was null or undefined when calling insertUserService.");
            }
            const localVarPath = `/account/services`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            const needsSerialization = typeof RequestBodySlug !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(RequestBodySlug !== undefined ? RequestBodySlug : {})
                : RequestBodySlug || "";
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateAccount(LightUser, options = {}) {
            if (LightUser === null || LightUser === undefined) {
                throw new base_1.RequiredError("LightUser", "Required parameter LightUser was null or undefined when calling updateAccount.");
            }
            const localVarPath = `/account`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            const needsSerialization = typeof LightUser !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(LightUser !== undefined ? LightUser : {})
                : LightUser || "";
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
}
function UserApiFp(configuration) {
    return {
        activateAccount(Activate, options) {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).activateAccount(Activate, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        checkSubscription(options) {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).checkSubscription(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        deleteUser(options) {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).deleteUser(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        deleteUserService(slug, options) {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).deleteUserService(slug, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        forgotEmail(EZCookieValue, options) {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).forgotEmail(EZCookieValue, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getAccount(options) {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).getAccount(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getSubscription(options) {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).getSubscription(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getUserService(slug, options) {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).getUserService(slug, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getUserServices(options) {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).getUserServices(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getUsernameValidity(username, options) {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).getUsernameValidity(username, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        insertUserService(RequestBodySlug, options) {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).insertUserService(RequestBodySlug, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        updateAccount(LightUser, options) {
            const localVarAxiosArgs = UserApiAxiosParamCreator(configuration).updateAccount(LightUser, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
}
class UserApi extends base_1.BaseAPI {
    activateAccount(Activate, options) {
        return UserApiFp(this.configuration).activateAccount(Activate, options)(this.axios, this.basePath);
    }
    checkSubscription(options) {
        return UserApiFp(this.configuration).checkSubscription(options)(this.axios, this.basePath);
    }
    deleteUser(options) {
        return UserApiFp(this.configuration).deleteUser(options)(this.axios, this.basePath);
    }
    deleteUserService(slug, options) {
        return UserApiFp(this.configuration).deleteUserService(slug, options)(this.axios, this.basePath);
    }
    forgotEmail(EZCookieValue, options) {
        return UserApiFp(this.configuration).forgotEmail(EZCookieValue, options)(this.axios, this.basePath);
    }
    getAccount(options) {
        return UserApiFp(this.configuration).getAccount(options)(this.axios, this.basePath);
    }
    getSubscription(options) {
        return UserApiFp(this.configuration).getSubscription(options)(this.axios, this.basePath);
    }
    getUserService(slug, options) {
        return UserApiFp(this.configuration).getUserService(slug, options)(this.axios, this.basePath);
    }
    getUserServices(options) {
        return UserApiFp(this.configuration).getUserServices(options)(this.axios, this.basePath);
    }
    getUsernameValidity(username, options) {
        return UserApiFp(this.configuration).getUsernameValidity(username, options)(this.axios, this.basePath);
    }
    insertUserService(RequestBodySlug, options) {
        return UserApiFp(this.configuration).insertUserService(RequestBodySlug, options)(this.axios, this.basePath);
    }
    updateAccount(LightUser, options) {
        return UserApiFp(this.configuration).updateAccount(LightUser, options)(this.axios, this.basePath);
    }
}
exports.UserApi = UserApi;
